import { render, staticRenderFns } from "./FragmentBroadcastTeaser.vue?vue&type=template&id=59f4cb0d&scoped=true"
import script from "./FragmentBroadcastTeaser.vue?vue&type=script&lang=ts"
export * from "./FragmentBroadcastTeaser.vue?vue&type=script&lang=ts"
import style0 from "./FragmentBroadcastTeaser.vue?vue&type=style&index=0&id=59f4cb0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4cb0d",
  null
  
)

export default component.exports